import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ProgramCard from '../../../components/ProgramCard';
import { getConfig } from '@edx/frontend-platform';
import { useDiscoverPrograms } from '../../../hooks/programs/useFetchPrograms'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import messages from '../messages';

const RecommendedPrograms = ({ intl, search = '', searchTags = [], noData = () => { }, hasData = () => { }, compact = false }) => {
  const { discoverPrograms, loading } = useDiscoverPrograms()
  const programDetails = discoverPrograms || [];

  const filteredProgramDetails = useMemo(() => {
    const filteredPrograms = programDetails.filter(program =>
      searchTags?.every(tag =>
        program.programTags.some(programTag => programTag.tag === tag)
      )
    );

    if (filteredPrograms.length > 0) {
      hasData();
    }

    const searchedPrograms = search
      ? filteredPrograms.filter(program =>
        program.name.toLowerCase().includes(search.toLowerCase())
      )
      : filteredPrograms;

    return compact ? searchedPrograms.slice(0, 3) : searchedPrograms;
  }, [programDetails, searchTags, search, compact, hasData]);

  if (!loading && filteredProgramDetails.length === 0) {
    noData();
    return null;
  }

  return (
    <div className="recommended-programs-container">
      <div className="recommended-programs__header">
        <div className="recommended-programs__title">{intl.formatMessage(messages.programs)}</div>
        <Link to={`${getConfig().DASHBOARD_URL}discover/programs`} className="recommended-programs__link">
          {intl.formatMessage(messages.seeAll)}
        </Link>
      </div>
      <div className="recommended-programs">
        {filteredProgramDetails.map((program) => (
          <ProgramCard
            key={program.id}
            title={program.name}
            description={program.description}
            estimatedTime={program.duration}
            durationMetric={program.durationMetric}
            link={`/program/${program.id}`}
            image={program.image}
            price={program.price}
            courseCount={program.programCoursesAggregate.agg_count}
            discover={true}
          />
        ))}
      </div>
    </div>
  );
}

RecommendedPrograms.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(RecommendedPrograms);